import React, { useEffect } from 'react';
import { env } from '../../env';

export function FacebookAppMeta(): React.JSX.Element | null {
  const id = env.VITE_FB_APP_ID;

  useEffect(() => {
    const prop = 'fb:app_id';
    const existing = document.head.querySelector<HTMLMetaElement>(`meta[property="${prop}"]`);

    if (!id) {
      // Remove stale tag if no app id
      if (existing) {
        document.head.removeChild(existing);
      }
      return;
    }

    if (existing) {
      existing.setAttribute('content', id);
      return;
    }

    const meta = document.createElement('meta');
    meta.setAttribute('property', prop);
    meta.setAttribute('content', id);
    document.head.appendChild(meta);
  }, [id]);

  return null;
}
